import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_behaviors_real'
const STORAGE_CATEGORIES = 'tr_v3_categories_real'

export default {
  state: {
    behaviors: [],
    categories: []
  },
  mutations: {
    SET_BEHAVIORS(state, list) {
      state.behaviors = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_BEHAVIOR(state, b) {
      state.behaviors.push(b)
      storage.set(STORAGE_KEY, state.behaviors)
    },
    UPDATE_BEHAVIOR(state, b) {
      const idx = state.behaviors.findIndex(x => x.behavior_id === b.behavior_id)
      if (idx >= 0) {
        state.behaviors.splice(idx, 1, b)
        storage.set(STORAGE_KEY, state.behaviors)
      }
    },
    DELETE_BEHAVIOR(state, id) {
      state.behaviors = state.behaviors.filter(x => x.behavior_id !== id)
      storage.set(STORAGE_KEY, state.behaviors)
    },
    TOGGLE_BEHAVIOR_STATUS(state, id) {
      const b = state.behaviors.find(x => x.behavior_id === id)
      if (b) {
        b.status = b.status === 1 ? 2 : 1
        storage.set(STORAGE_KEY, state.behaviors)
      }
    },
    SET_CATEGORIES(state, list) {
      state.categories = list
      storage.set(STORAGE_CATEGORIES, list)
    },
    ADD_CATEGORY(state, c) {
      state.categories.push(c)
      storage.set(STORAGE_CATEGORIES, state.categories)
    },
    UPDATE_CATEGORY(state, c) {
      const idx = state.categories.findIndex(x => x.category_id === c.category_id)
      if (idx >= 0) {
        state.categories.splice(idx, 1, c)
        storage.set(STORAGE_CATEGORIES, state.categories)
      }
    },
    DELETE_CATEGORY(state, id) {
      state.categories = state.categories.filter(x => x.category_id !== id)
      storage.set(STORAGE_CATEGORIES, state.categories)
    },
    REORDER_CATEGORIES(state, list) {
      state.categories = list
      storage.set(STORAGE_CATEGORIES, state.categories)
    },
    BATCH_TOGGLE_BEHAVIOR_STATUS(state, payload) {
      const { ids, status } = payload
      state.behaviors.forEach(b => {
        if (ids.includes(b.behavior_id)) {
          b.status = status
        }
      })
      storage.set(STORAGE_KEY, state.behaviors)
    },
    BATCH_UPDATE_BEHAVIOR_CATEGORY(state, payload) {
      const { ids, category_id } = payload
      state.behaviors.forEach(b => {
        if (ids.includes(b.behavior_id)) {
          b.category_id = category_id
        }
      })
      storage.set(STORAGE_KEY, state.behaviors)
    }
  },
  getters: {
    allBehaviors: state => state.behaviors,
    allCategories: state => state.categories,
    activeBehaviors: state => state.behaviors.filter(b => b.status !== 2),
    activeCategories: state => state.categories.filter(c => c.status === 1),
    behaviorsByCategory: state => categoryId => state.behaviors.filter(b => b.category_id === categoryId),
    categoryById: state => id => state.categories.find(c => c.category_id === id),
    taskBehaviors: (state, getters, rootState) => {
      const taskId = rootState.tasks && rootState.tasks.currentTask && rootState.tasks.currentTask.task_id
      return state.behaviors.filter(b => {
        if (b.status === 2) return false
        if (b.task_id === null || b.task_id === undefined) return true
        if (taskId && b.task_id === taskId) return true
        return false
      })
    }
  }
}
